import React, { Suspense } from 'react';
import { Box, Container, CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet, useParams } from '@tanstack/react-router';
import theme from '../theme';
import { AppHeader } from './ui/AppHeader';
import { AppProvider } from '@context/index';
import { hideTanstackDevTools } from '@api/auth/config';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Return a no-op component in production
    : React.lazy(() =>
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

const ReactQueryDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools,
        })),
      );

export function RootLayout() {
  const { slug } = useParams({ strict: false });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
        <Container maxWidth='xl' disableGutters>
          <AppProvider slug={slug}>
            <AppHeader />
            <main>
              <Outlet />
            </main>
          </AppProvider>
        </Container>
      </Box>
      {process.env.NODE_ENV === 'development' && !hideTanstackDevTools && (
        <Suspense fallback={null}>
          <TanStackRouterDevtools />
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </ThemeProvider>
  );
}
